import { uiText } from '../../i18n/uiText';
import React, { useEffect, useRef, useState } from 'react';
import { Trash2, X } from 'lucide-react';
import Dialog from '../common/Dialog';
import { getApiErrorMessage } from '../../api';
import '../../styles/audit-report.css';

export default function RemoveAuditQuestionDialog({ question, onClose, onRemove }) {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const pending = useRef(false);
  const feedbackRef = useRef(null);
  useEffect(() => { if (error) feedbackRef.current?.focus({ preventScroll: true }); }, [error]);
  const remove = async event => {
    event.preventDefault();
    if (pending.current) return;
    pending.current = true; setBusy(true); setError('');
    try { await onRemove(question, reason.trim() || null); }
    catch (requestError) { setError(getApiErrorMessage(requestError)); }
    finally { pending.current = false; setBusy(false); }
  };
  return <Dialog size="sm" role="alertdialog" labelledBy="remove-audit-question-title" describedBy="remove-audit-question-description" onClose={onClose} closeDisabled={busy}>
    <form onSubmit={remove}>
      <div className="ap-dialog__header">
        <h2 className="ap-dialog__title" id="remove-audit-question-title" data-dialog-heading tabIndex={-1}><Trash2 size={20} />{uiText("Удалить вопрос из аудита?")}</h2>
        <button type="button" className="ap-dialog__close" aria-label={uiText("Закрыть")} disabled={busy} onClick={onClose}><X size={18} /></button>
      </div>
      <div className="ap-dialog__body audit-question-removal-body">
        <blockquote className="audit-question-removal-preview">{question.text}</blockquote>
        <p id="remove-audit-question-description">{uiText("Вопрос исчезнет из чек-листа и новых отчётов только этого аудита. Общий шаблон и другие аудиты не изменятся.")}</p>
        <p>{uiText("Сохранённые ответы, файлы, замечания и ПКПД не удаляются. Действие и причина попадут в историю аудита. Ранее скачанные документы не изменятся.")}</p>
        <label className="audit-question-removal-reason"><span>{uiText("Причина удаления (необязательно)")}</span><textarea className="ap-control" rows={3} maxLength={2000} value={reason} onChange={event => setReason(event.target.value)} disabled={busy} placeholder={uiText("Например: вопрос добавлен по ошибке и не относится к области аудита")} /></label>
      </div>
      {error ? <div className="audit-report-feedback is-error" role="alert" ref={feedbackRef} tabIndex={-1}>{error}</div> : null}
      <div className="ap-dialog__footer">
        <button type="button" className="ap-button ap-button--secondary" disabled={busy} onClick={onClose}>{uiText("Отмена")}</button>
        <button type="submit" className="ap-button ap-button--danger" disabled={busy}><Trash2 size={16} />{busy ? uiText("Удаляем…") : uiText("Удалить из чек-листа")}</button>
      </div>
    </form>
  </Dialog>;
}
